import React from 'react'
import ReactDOM from 'react-dom'
import './styles/css/index.css'
import {HashRouter} from 'react-router-dom'
import App from './components/App'
import {unregister} from './registerServiceWorker'
import config from "./config/dev";

unregister()

const root = document.getElementById('root');
// const configUrl = `${config.ENDPOINT_BASE_URL}app-configuration`
// const configPromise = fetch(configUrl)
// configPromise.then((res) => res.json())
//     .then(config => ReactDOM.render(
//         <HashRouter>
//             <App config={config}/>
//         </HashRouter>,
//             root
//         )
//     );

ReactDOM.render(
    <HashRouter>
        <App config={config}/>
    </HashRouter>
    , root
)



// WEBPACK FOOTER //
// ./src/index.js